import { useNavigate } from "react-router";
import { loadStripe } from "@stripe/stripe-js";
import { useContext, useRef } from "react";
import { GetlifeContext } from "../../context/GetLifeContext.context";
import HttpCheckoutRepository from "../../api/request/Checkout/Checkout.service";
import {
  track,
  trackPaymentFailed,
  trackSubmissionError,
  trackThreeDsCompleted,
} from "../../helpers/Tracking";

// Estados del PaymentIntent tras el 3D Secure del cobro de validación.
const PAYMENT_FAILED_STATUSES = ["requires_payment_method", "canceled"];

/**
 * Telemetría de la vuelta del banco según el estado del PaymentIntent:
 * succeeded → threeds_completed (succeeded) + funds_verified; fallido →
 * threeds_completed (failed) + payment_failed. Otros estados (processing…) no
 * dicen el resultado: no se emite nada.
 */
export const reportThreeDsReturn = (paymentIntent) => {
  const status = paymentIntent?.status;
  if (status === "succeeded") {
    trackThreeDsCompleted("ensure_funds", "succeeded");
    track("funds_verified", {});
  } else if (PAYMENT_FAILED_STATUSES.includes(status)) {
    trackThreeDsCompleted("ensure_funds", "failed");
    trackPaymentFailed("ensure_funds", paymentIntent?.last_payment_error || { code: status });
  }
};

//import SplitForm from './demos/SplitForm';

export default function CardSetupForm() {
  const { token, leadId, setLoading } =
    useContext(GetlifeContext);

  const checkoutRepository = new HttpCheckoutRepository(leadId, token);

  const navigate = useNavigate();
  // getStripe corre en cada render: el resultado del 3DS y el fallo al
  // guardarlo se cuentan una vez cada uno.
  const reportedRef = useRef(false);
  const reportOnce = (report) => {
    if (reportedRef.current) return;
    reportedRef.current = true;
    report();
  };
  const saveFailedRef = useRef(false);

  const getStripe = async () => {
    setLoading(true);
    const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY, {
      locale: "es",
      stripeAccount: process.env.REACT_APP_STRIPE_ACCOUNT,
    });
    let params = new URLSearchParams(window.location.search);
    let paymentIntentSecret = params.get("payment_intent_client_secret");
    let paymentIntent;
    try {
      const result = await stripe.retrievePaymentIntent(paymentIntentSecret);
      if (!result?.paymentIntent) throw result?.error || new Error("sin PaymentIntent");
      paymentIntent = result.paymentIntent;
    } catch (error) {
      // Stripe no dice cómo fue el cobro: fallo del cobro, solo payment_failed.
      reportOnce(() => trackPaymentFailed("ensure_funds", error));
      setLoading(false);
      navigate("/waitingvalidation");
      return stripe;
    }
    reportOnce(() => reportThreeDsReturn(paymentIntent));
    try {
      await checkoutRepository.saveStatus(paymentIntent.status);
      setLoading(false);
      navigate("/payment/5");
    } catch (error) {
      // Stripe respondió pero el backend no guardó el estado.
      if (!saveFailedRef.current) {
        saveFailedRef.current = true;
        trackSubmissionError(error);
      }
      setLoading(false);
      navigate("/waitingvalidation");
    }
    return stripe;
  };

  getStripe();
  return <></>;
}
